// update along with app/lib/enums/process_status.py
const ProcessStatus = {
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

const ProcessStatusLabels = {
  [ProcessStatus.PROCESSING]: 'Processing',
  [ProcessStatus.DONE]: 'Done',
  [ProcessStatus.ERROR]: 'Error',
};

export default ProcessStatus;
export { ProcessStatusLabels };
